import script from "./WWTTrackedContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./WWTTrackedContent.vue?vue&type=script&setup=true&lang=ts"

import "./WWTTrackedContent.vue?vue&type=style&index=0&id=589ebd3c&lang=less"

const __exports__ = script;

export default __exports__